import useMutationSupplierCreateUpdate from './supplier-use-mutation-create-update';
import useMutationSupplierDelete from "./supplier-use-mutation-delete";


export const supplierUseMutation = {
  createUpdate: useMutationSupplierCreateUpdate,
  delete: useMutationSupplierDelete,
}